import React from "react";

const IntermediatePage = () => {
  return <></>;
};

export default IntermediatePage;
